import React, {FunctionComponent, useEffect} from 'react';

import {Route, useLocation, Routes} from 'react-router-dom';

import AdminContent from '../admin/AdminContent';
import ClientContent from '../client/ClientContent';
import {routeMap} from '../../config/routing/Routes';
import {AnimatePresence} from 'framer-motion';

interface Props {}

const Content: FunctionComponent<Props> = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <React.Fragment>
            <AnimatePresence mode={'wait'}>
                <Routes location={location} key={location.key}>
                    <Route path={'/admin'} element={<AdminContent />}>
                        { routeMap.admin.map(route =>
                            <Route key={route.path} path={route.path} element={<route.component />} />
                        ) }
                    </Route>

                    <Route element={<ClientContent />}>
                        { routeMap.client.map(route =>
                            <Route key={route.path} path={route.path} element={<route.component />} />
                        ) }
                    </Route>
                </Routes>
            </AnimatePresence>
        </React.Fragment>
    );
};

export default Content;
